import { Stack, Grid, Button, Typography } from '@mui/material';
import useValidateDomain from '../../hooks/useValidateDomain';
import TextField from '../text-field/TextField';

import {
  useGetAuthenticationQuery,
  useCreateDomainMutation,
} from '../../services/ADapi';

const CreateDomain = () => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const [createDomain] = useCreateDomainMutation();

  const {
    name,
    nameIsBlur,
    nameError,
    formIsValid,
    formIsSuccess,
    domainData,
    nameHandler,
    blurHandler,
    setName,
    setNameError,
    setFormIsValid,
    setFormIsSuccess,
  } = useValidateDomain();

  const formSend = async (e) => {
    e.preventDefault();

    try {
      await createDomain({
        user_id,
        payload: domainData,
      }).unwrap();
      setFormIsSuccess(!formIsSuccess);
    } catch (error) {
      console.error(error);
    }

    setFormIsValid(false);

    setName('');
    setNameError(' ');
  };

  return (
    <Stack component="form">
      <Typography variant="h1" component="h2">
        Create Domain
      </Typography>
      <Stack
        direction={{ md: 'row' }}
        alignItems={{ md: 'flex-end' }}
        justifyContent={{ md: 'space-between' }}
        gap={3}
        pt={{ xs: 2, md: 4 }}
        pb={3}
      >
        <Grid item xs={12} md={7}>
          <TextField
            id="domain"
            name="domain"
            label="Name"
            value={name}
            size="small"
            onChange={nameHandler}
            onBlur={blurHandler}
          />
          {nameIsBlur && nameError && (
            <span className="validate-error">{nameError}</span>
          )}
        </Grid>
        <Grid item xs={12} md={5}>
          <Button
            type="submit"
            variant="contained"
            disabled={!formIsValid}
            size="large"
            onClick={formSend}
            sx={{
              width: '100%',
              '&.Mui-disabled': {
                backgroundColor: 'primary.light',
                color: '#fff',
              },
            }}
          >
            Create
          </Button>
        </Grid>
      </Stack>
    </Stack>
  );
};

export default CreateDomain;
